module.exports = __webpack_public_path__ + "static/media/header.19bea360.jpg";